import dayjs from "../../utils/dayjs";
function toTimeDuration(target) {
  if (dayjs.isDuration(target)) {
    return target;
  }
  const date = dayjs(target);
  const hours = date.hour();
  const minutes = date.minute();
  return dayjs.duration({ hours, minutes }).clone();
}
function findNearestLeftTimeSlot(time, slots, inclusive = false) {
  for (let i = slots.length - 1; i >= 0; i -= 1) {
    const slotTime = slots[i].asMinutes();
    if (inclusive && slotTime === time || slotTime < time) {
      return slots[i];
    }
  }
  return dayjs.duration(0);
}
const _TimeSlotting = class {
  constructor(start = dayjs.duration({ hours: 0 }), end = dayjs.duration({ hours: 23 }), step = dayjs.duration({ hours: 1 }), minuteIntervalsEnabled = true) {
    this.startTime = start.clone().asMinutes();
    this.endTime = end.clone().asMinutes();
    this.stepTime = step.clone().asMinutes();
    this.minuteIntervalsEnabled = minuteIntervalsEnabled;
    this.hourSlots = [];
    this.minuteSlots = [];
    this.createSlots(this.startTime, this.endTime);
    this.createMinuteSlots();
  }
  createSlots(start, end) {
    const numOfOptions = Math.floor((end - start) / this.stepTime) + 1;
    this.hourSlots = Array(numOfOptions).fill(0).map((_, i) => start + i * this.stepTime).map((value) => dayjs.duration({ minutes: value }).clone());
  }
  setStep(newStep = dayjs.duration({ hours: 1 })) {
    this.stepTime = newStep.clone().asMinutes();
    this.createSlots(this.startTime, this.endTime);
  }
  setMinuteIntervalsEnabled(minuteIntervalsEnabled) {
    this.minuteIntervalsEnabled = minuteIntervalsEnabled;
    this.createMinuteSlots();
  }
  findClosestLeft(target, inclusive = false) {
    const targetTimeInMinutes = toTimeDuration(target).asMinutes();
    const hoursSlot = findNearestLeftTimeSlot(targetTimeInMinutes, this.hourSlots, inclusive);
    const remainingMinutes = targetTimeInMinutes - hoursSlot.asMinutes();
    const minutesSlot = findNearestLeftTimeSlot(remainingMinutes, this.minuteSlots, inclusive);
    return dayjs.duration({ hours: hoursSlot.hours(), minutes: minutesSlot.minutes() }).clone();
  }
  findClosestLeftOrSame(target) {
    return this.findClosestLeft(target, true);
  }
  findClosestRight(target) {
    const targetTime = toTimeDuration(target);
    for (let i = 0, carryHour = false; i < this.hourSlots.length; i += 1) {
      const slotTime = this.hourSlots[i].hours();
      if (carryHour || slotTime > targetTime.hours())
        return toTimeDuration(this.hourSlots[i]);
      if (slotTime === targetTime.hours()) {
        for (let j = 0; j < this.minuteSlots.length; j += 1) {
          if (this.minuteSlots[j].minutes() > targetTime.minutes()) {
            return dayjs.duration({
              hours: this.hourSlots[i].hours(),
              minutes: this.minuteSlots[j].minutes()
            }).clone();
          }
        }
        carryHour = true;
      }
    }
    return this.hourSlots[0].add({ days: 1 });
  }
  createHourOptions(min = dayjs.duration(0)) {
    return this.hourSlots.map((duration) => ({
      duration,
      disabled: duration.hours() < min.hours()
    }));
  }
  createMinuteOptions(min = dayjs.duration(0)) {
    return this.minuteSlots.map((duration) => ({
      duration,
      disabled: duration.minutes() < min.minutes()
    }));
  }
  createMinuteSlots() {
    this.minuteSlots = this.minuteIntervalsEnabled ? _TimeSlotting.MINUTES_INTERVALS.map((minute) => dayjs.duration({ minutes: minute }).clone()) : [];
  }
};
let TimeSlotting = _TimeSlotting;
TimeSlotting.MINUTES_INTERVALS = [0, 15, 30, 45];
export {
  TimeSlotting as default,
  toTimeDuration
};
